import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {

    cache: [],

    loading: false,

    panelStats: {
        'createdAt': 0,
        'count': 0,
        'countActive': 0,
        'activeMultiplier': 0,

        'recruitmentCost': {
            'average': 0,
            'sum': 0,
        },
        'recruitmentCostActive': {
            'average': 0,
            'sum': 0,
        },
        'revenue': {
            'average': 0,
            'sum': 0,
        },
        'rewards': {
            'average': 0,
            'sum': 0,
        },
        'rewardsRedeemed': {
            'average': 0,
            'sum': 0,
        },
        'rewardsLiability': {
            'average': 0,
            'sum': 0,
        }
    },

    panelFilters: [
        {
            type: 'timeInPanel',
            name: 'Time in panel',
            description: 'Filter panelist based on how long they have been in panel',
            clickable: true,
            icon: 'mdi-account-clock',
            model: false,
            dialog: false,
            menu:
                {
                    type: 'radio',
                    options: [
                        {value: "1", name: "Less than one month", model: false},
                        {value: "3", name: "Less than 3 months", model: false},
                        {value: "6", name: "Less than 6 months", model: false},
                        {value: "12", name: "Less than 1 year", model: false}
                    ]
                }
        },
        {
            type: 'activityPeriod',
            name: 'Activity in period',
            description: 'Include only panelists who had activity in the specified period',
            clickable: true,
            icon: 'mdi-calendar-clock',
            model: false,
            dialog: false,
            menu:
                {
                    type: 'radio',
                    options: [
                        {value: "1", name: "Past month", model: false},
                        {value: "3", name: "Past 3 months", model: true},
                        {value: "6", name: "Past 6 months", model: false},
                        {value: "12", name: "Past 1 year", model: false}
                    ]
                }
        },
        {
            type: 'queryFilter',
            name: 'Query filter',
            description: 'Create a new ad hoc filter',
            icon: 'mdi-filter',
            clickable: true,
            model: false,
            custom: {
                jsonQuery: null,
                jsonFilter: null
            }
        }
    ],

    panelReportingMode: 'average',

    recruitmentStats: {
        createdAt: null,
        average: [],
        sum: []
    },

    recruitmentFilters: [
        {
            type: 'timeInPanel',
            name: 'Time in panel',
            description: 'Filter panelist based on how long they have been in panel',
            clickable: true,
            icon: 'mdi-account-clock',
            model: false,
            dialog: false,
            menu:
                {
                    type: 'radio',
                    options: [
                        {value: "1", name: "Less than one month", model: false},
                        {value: "3", name: "Less than 3 months", model: false},
                        {value: "6", name: "Less than 6 months", model: false},
                        {value: "12", name: "Less than 1 year", model: false}
                    ]
                }
        },
        {
            type: 'activityPeriod',
            name: 'Activity in period',
            description: 'Include only panelists who had activity in the specified period',
            clickable: true,
            icon: 'mdi-calendar-clock',
            model: false,
            dialog: false,
            menu:
                {
                    type: 'radio',
                    options: [
                        {value: "1", name: "Past month", model: false},
                        {value: "3", name: "Past 3 months", model: true},
                        {value: "6", name: "Past 6 months", model: false},
                        {value: "12", name: "Past 1 year", model: false}
                    ]
                }
        },
        {
            type: 'queryFilter',
            name: 'Query filter',
            description: 'Create a new ad hoc filter',
            icon: 'mdi-filter',
            clickable: true,
            model: false,
            custom: {
                jsonQuery: null,
                jsonFilter: null
            }
        },
        {
            type: 'activeOnly',
            name: 'Enabled sources only',
            description: 'Filter out recruitment sources that are disabled',
            icon: 'mdi-checkbox-marked-circle-outline',
            model: true
        },

    ],

    recruitmentReportingMode: 'average',

    subPanelStats: {
        createdAt: null,
        average: [],
        sum: []
    },

    subPanelFilters: [
        {
            type: 'timeInPanel',
            name: 'Time in panel',
            description: 'Filter panelist based on how long they have been in panel',
            clickable: true,
            icon: 'mdi-account-clock',
            model: false,
            dialog: false,
            menu:
                {
                    type: 'radio',
                    options: [
                        {value: "1", name: "Less than one month", model: false},
                        {value: "3", name: "Less than 3 months", model: false},
                        {value: "6", name: "Less than 6 months", model: false},
                        {value: "12", name: "Less than 1 year", model: false}
                    ]
                }
        },
        {
            type: 'activityPeriod',
            name: 'Activity in period',
            description: 'Include only panelists who had activity in the specified period',
            clickable: true,
            icon: 'mdi-calendar-clock',
            model: false,
            dialog: false,
            menu:
                {
                    type: 'radio',
                    options: [
                        {value: "1", name: "Past month", model: false},
                        {value: "3", name: "Past 3 months", model: true},
                        {value: "6", name: "Past 6 months", model: false},
                        {value: "12", name: "Past 1 year", model: false}
                    ]
                }
        },
        {
            type: 'queryFilter',
            name: 'Query filter',
            description: 'Create a new segment filter for custom ad hoc filtering logic',
            icon: 'mdi-filter',
            clickable: true,
            model: false,
            custom: {
                jsonQuery: null,
                jsonFilter: null
            }
        }
    ],

    subPanelReportingMode: 'average',
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

